import * as React from "react"
import { Flex, Box } from "@chakra-ui/react"
import { brandingSelector } from "../../../recoil/atoms/room"
import { Icon } from "../../common/icons"
import { useRecoilValue, useSetRecoilState } from "recoil"
import {
  auctionFinalResultSelector,
  auctionFinalResultAtom
} from "../../../recoil/atoms/auction"
import { localUserIdAtom } from "../../../recoil/atoms/users"
import { blendWithWhiteBackground, numberWithCommas } from "../../../util"
import { AuctionFinalOverlayProps } from "./auction.interface"
import { IoClose } from "react-icons/io5"
import { useTranslation } from "react-i18next"
import { MODAL_Z_INDEX } from "../../../constants"

const _AuctionFinalOverlay: React.FC<AuctionFinalOverlayProps> = ({
  isMobile,
  isLandscape
}) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const setAuctionFinalResult = useSetRecoilState(auctionFinalResultSelector)
  const { idUser, currency, bid } = useRecoilValue(auctionFinalResultAtom)
  const localUserId = useRecoilValue(localUserIdAtom)
  const handleCloseModal = () => {
    setAuctionFinalResult({ type: "UPDATE", payload: { isFinalModal: false } })
  }
  const { t } = useTranslation()
  return (
    <Box
      width="100vw"
      height="100vh"
      position="fixed"
      background="white"
      zIndex={MODAL_Z_INDEX}
      top="0"
      left="0"
      backgroundColor="rgba(255, 255, 255, 0.5)"
    >
      <Flex
        minW={isMobile && !isLandscape ? "300px" : "400px"}
        width={isMobile ? "50vw" : "500px"}
        position="absolute"
        top="50%"
        left="50%"
        padding="0.5rem"
        marginRight="-50%"
        transform="translate(-50%, -50%)"
        flexDirection="column"
        backgroundColor="rgba(255, 255, 255)"
        borderRadius="0.375rem"
        borderWidth="1px"
        borderStyle="solid"
        borderColor={roomStyles.servicePanelElementBorder ?? "gray.300"}
        bg={
          blendWithWhiteBackground(
            roomStyles?.servicePanelElementModalBackground
          ) ?? "white"
        }
        boxShadow={`0 0 15px ${
          roomStyles?.servicePanelElementBorder ?? "#e2e8f0"
        }`}
        color={roomStyles?.servicePanelElementPrimaryText ?? "black"}
      >
        {/*  {isMobile ? ( */}
        <Flex
           bg={
            blendWithWhiteBackground(
              roomStyles?.servicePanelElementModalBackground
            ) ?? "white"
          }
          pos="absolute"
          width="19px"
          height="19px"
          borderRadius="50%"
          right="-9px"
          top="-9px"
          alignItems="center"
          justifyContent="center"
          border="1px solid"
          borderColor={roomStyles.servicePanelElementBorder ?? "#CBD5E0"}
          cursor={"pointer"}
          zIndex={1}
          onClick={handleCloseModal}
        >
          <Icon
            src={IoClose}
            fontSize="0.8rem"
            marginLeft="1px"
            color={roomStyles?.servicePanelElementPrimaryText ?? "#000"}
          />
        </Flex>

        <Box
          fontSize={isMobile ? "1.3rem" : "2.25rem"}
          lineHeight="1.5"
          fontWeight="700"
          justifyContent="center"
          zIndex="10000001"
          textAlign="center"
        >
          {idUser !== localUserId
            ? `${t("The auction is now over")}.`
            : t("Congratulations!")}
        </Box>
        {+bid !== 0 && (
          <Flex
            alignItems="center"
            justifyContent="center"
            marginTop="0.4rem"
            textAlign="center"
            flexDirection="column"
          >
            {idUser !== localUserId ? (
              <Flex>{`${t(
                "The winning bid was"
              )} ${currency} ${numberWithCommas((+bid).toFixed(2))}`}</Flex>
            ) : (
              <>
                <Box>{t("You have won the auction!")}</Box>
                <Box>{`${t(
                  "Your winning bid was"
                )} ${currency} ${numberWithCommas((+bid).toFixed(2))}`}</Box>
                <Box>{t("You will be contacted soon.")}</Box>
              </>
            )}
          </Flex>
        )}
      </Flex>
    </Box>
  )
}

export const AuctionFinalOverlay = React.memo(_AuctionFinalOverlay)
